import { Crown } from "lucide-react";

/** Shared member avatar — uploaded image when available, otherwise the default
 *  premium PlusMaker crown monogram. Purely presentational; never breaks when
 *  avatarUrl is missing. */
export default function MemberAvatar({ avatarUrl, size = 40, ring = "border-[#D4AF37]/40", alt = "Member avatar", testId }) {
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={alt}
        data-testid={testId}
        className={`rounded-full object-cover border-2 shrink-0 ${ring}`}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      data-testid={testId}
      className={`rounded-full flex items-center justify-center border-2 shrink-0 ${ring}`}
      style={{ width: size, height: size, background: "linear-gradient(145deg, #1A1607, #0B0C10)" }}
    >
      <Crown style={{ width: size * 0.42, height: size * 0.42, color: "#D4AF37" }} strokeWidth={1.6} />
    </div>
  );
}
